import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Phone } from "lucide-react";
import { FAQ, COMPANY } from "../lib/data";
import Reveal from "./Reveal";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-slate-50 py-20 md:py-28 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="overline">Questions fréquentes</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Tout ce que vous devez savoir
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-lg text-ink-soft">
              Une question sans réponse ? Appelez-nous, nous sommes disponibles à toute heure.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <a href={COMPANY.phoneHref} className="btn-primary mt-6">
              <Phone className="h-4 w-4" /> {COMPANY.phone}
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Accordion type="single" collapsible className="w-full space-y-3">
              {FAQ.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="card-soft border border-slate-200 px-6 hover:translate-y-0"
                >
                  <AccordionTrigger className="font-display font-bold text-ink text-base md:text-lg text-left hover:no-underline py-5 [&>svg]:text-brand">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink-soft text-base leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
